const formatByPattern = (str: string, sections: any[]): string => {
  let result = '';
  let i = 0;
  for (const section of sections) {
    if (i >= str.length) break;

    if (typeof section === 'number') {
      result += str.substring(i, i + section);
      i += section;
    } else {
      result += section;
    }
  }

  if (i < str.length) {
    result += str.substring(i);
  }
  return result;
};

export const formatToPattern = (pattern: string, value: string) => {
  const sections: any[] = [];
  let i = 0;
  let prevPlaceholder = undefined;
  for (const c of pattern) {
    const placeholder = /[a-zA-Z0-9]/.test(c);
    if (prevPlaceholder === undefined) {
      prevPlaceholder = placeholder;
    }

    if (placeholder !== prevPlaceholder) {
      prevPlaceholder = placeholder;
      i++;
    }

    if (placeholder) {
      if (i === sections.length) sections[i] = 1;
      else sections[i]++;
    } else {
      if (i === sections.length) sections[i] = c;
      else sections[i] += c;
    }
  }

  return formatByPattern(value, sections);
};
